module.exports = __webpack_public_path__ + "img/tiktok.e3b23f05.svg";